<template>
  <f7-page>
    <div>
      <div>
        <div class="cardRegister card">
          <div class="summary-header">
            <div class="summary-title">
              <div class="summary-icon"></div>
              <div class="summary-text">
                {{ $t('SamplesRegisterEdit') }}
                {{ this.detailedSample.CodMuestra }}
              </div>
            </div>
          </div>
          <SamplesRegisteredDetails :store="detailedSample" />
          <div
            class="content-setting display-flex justify-content-flex-start margin-top"
          >
            <f7-button
              class="cancelButton"
              fill
              outline
              type="default"
              styling-mode="contained"
              @click="goBack"
            >
              {{ $t('cancel') }}
            </f7-button>
            <f7-button
              class="botones-registrar whiteFontColor margin-left saveButton"
              style="width: 130px"
              fill
              outline
              type="default"
              styling-mode="contained"
              name="SaveSampleConfirm"
              @click="SaveSample"
            >
              {{ this.$t('save') }}
            </f7-button>
          </div>
        </div>
      </div>
    </div>
    <ReplacementSampleConfirmPopUp
      :visible="replacementSamplePopupVisible"
      :code="replacementSampleCode"
      @close="closeReplacementSamplePopup"
    />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SamplesRegisteredDetails from '@/components/SamplesRegister/SamplesRegisteredDetails/index.vue';
import ReplacementSampleConfirmPopUp from '@/components/SamplesRegister/SamplesRegisteredDetails/ReplacementSampleConfirmPopUp.vue';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import EventBus from '@/services/event-bus';

export default {
  components: {
    ReplacementSampleConfirmPopUp,
    SamplesRegisteredDetails,
  },
  data() {
    return {
      Customstore: null,
      lastFormData: null,
      replacementSamplePopupVisible: false,
      replacementSampleCode: '',
      originalFamilyIdSnapshot: null,
    };
  },
  computed: {
    urlName() {
      if (this.lastRouteGeotoolboxSamples) {
        return 'GisActionsPage';
      }
      return this.lastRouteHome ? 'Home' : 'Home';
    },
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteGeotoolboxSamples',
    ]),
    ...mapState('Offers', ['detallesPresupuestos']),
    ...mapState('samplesRegisterModule', [
      'detailedSample',
      'invoice',
      'invoiceCode',
      'invoiceSamples',
      'invoiceDetails',
    ]),
  },
  async mounted() {
    this.originalFamilyIdSnapshot = this.normalizeFamilyId(
      this.detailedSample
    );
    await this.fetchDetallesPresupuestos(
      this.detailedSample.CodPresupuesto
    ).catch((error) => {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(error)
          ),
          width: 550,
        },
        'error'
      );
    });
    const filteredAnalysisType = this.detallesPresupuestos.find(
      (item) => item.CodArticulo === this.detailedSample.CodArticulo
    );
    if (filteredAnalysisType.TipoServicioLmr !== null) {
      this.Customstore = {
        ...this.detailedSample,
        paisesLMR: [filteredAnalysisType.TipoServicioLmr.PaisesLMR],
      };
    }
  },
  created() {
    EventBus.$on('formData2', this.receiveMessage);
  },
  beforeDestroy() {
    EventBus.$off('formData2', this.receiveMessage);
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('SamplesList.orderList'),
        disabled: false,
        page: 'SamplesList',
        active: false,
      },
      {
        name: this.$t('sample_detail'),
        disabled: false,
        page: 'SamplesRegister',
        active: true,
      },
    ]);
  },
  methods: {
    shouldReturnToRegisterConfirmation() {
      return (
        this.detailedSample?.navigationSource ===
        'samplesRegisterConfirmation'
      );
    },
    navigateAfterSave() {
      const targetRoute = this.shouldReturnToRegisterConfirmation()
        ? {
            name: 'SamplesRegister',
            query: { tab: '1' },
          }
        : { name: 'SamplesList' };

      this.$f7router.navigate(targetRoute, {
        animate: true,
        transition: 'f7-fade',
      });
    },
    normalizeDateOnly(value) {
      if (!value) return null;
      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) {
        return null;
      }
      return new Date(
        parsedDate.getFullYear(),
        parsedDate.getMonth(),
        parsedDate.getDate()
      );
    },
    normalizeFamilyId(sample) {
      const rawFamilyId =
        sample?.idFamiliaTM ??
        sample?.idFamilia ??
        sample?.FamiliaTM ??
        sample?.Familia ??
        null;
      if (rawFamilyId === null || rawFamilyId === undefined || rawFamilyId === '') {
        return null;
      }
      const normalizedFamilyId = Number(rawFamilyId);
      return Number.isNaN(normalizedFamilyId)
        ? rawFamilyId
        : normalizedFamilyId;
    },
    isShippingDateInFuture() {
      const shippingDate = this.normalizeDateOnly(
        this.invoiceDetails?.FechaRecogidaDate ||
          this.invoiceDetails?.FechaRecogida
      );
      const today = this.normalizeDateOnly(new Date());

      if (!shippingDate || !today) {
        return false;
      }

      return shippingDate.getTime() > today.getTime();
    },
    shouldCreateReplacementSample() {
      const currentFamilyId = this.normalizeFamilyId(
        this.lastFormData
      );
      const originalFamilyId =
        this.originalFamilyIdSnapshot ??
        this.normalizeFamilyId(this.detailedSample);
      const hasFamilyChanged =
        String(currentFamilyId ?? '') !==
        String(originalFamilyId ?? '');

      if (!hasFamilyChanged) {
        return false;
      }
      return true;
    },
    buildRegisterPayloadFromEditedSample() {
      return {
        CodCliente:
          this.lastFormData?.CodCliente ||
          this.detailedSample?.CodCliente,
        idAlbaran:
          this.lastFormData?.idAlbaran ||
          this.detailedSample?.idAlbaran,
        CodAlbaran:
          this.lastFormData?.CodAlbaran ||
          this.detailedSample?.CodAlbaran ||
          this.invoiceDetails?.CodAlbaran ||
          '',
        CodPresupuesto: this.lastFormData?.CodPresupuesto,
        CodLinea: this.lastFormData?.CodLinea,
        Articulo: this.lastFormData?.CodArticulo,
        FamiliaTM: this.lastFormData?.idFamiliaTM,
        idSubFamiliaTM: this.lastFormData?.idSubFamiliaTM,
        idTipoMuestra: this.lastFormData?.IdTipoMuestra,
        SubTipoMuestra: this.lastFormData?.IdSubTipoMuestra,
        lote: this.lastFormData?.Lote,
        DescripcionMuestra: this.lastFormData?.SampleDescription,
        Parcelas: this.lastFormData?.Parcelas,
        FincaLiteral: this.lastFormData?.FincaLiteral,
        Parcela: this.lastFormData?.Parcela,
        ParcelaLiteral: this.lastFormData?.ParcelaLiteral,
        idNivelPunto: this.lastFormData?.idNivelPunto,
        NivelPuntoCoordLiteral:
          this.lastFormData?.NivelPuntoCoordLiteral,
        CultivoOrganico: this.lastFormData?.organicFarming,
        lmr: this.lastFormData?.lmr,
        trazaCultivo: this.lastFormData?.trazaCultivo,
        cma: this.lastFormData?.cma,
        Legislacion: this.lastFormData?.idLegislacion,
        PrecioAT: this.lastFormData?.PrecioAT,
        Observaciones: this.lastFormData?.Observaciones,
        SamplingDate: this.lastFormData?.FechaMuestreo,
        cloroResidual: this.lastFormData?.cloroResidual,
      };
    },
    syncInvoiceTotalsFromSamples(samples) {
      const recalculatedSamplesTotal = (samples || []).reduce(
        (total, sample) => total + Number(sample?.PrecioAT || 0),
        0
      );
      const invoiceIdentifier =
        this.detailedSample?.idAlbaran ||
        this.invoiceDetails?.idAlbaran;

      const updatedInvoices = (this.invoice || []).map((item) => {
        if (String(item.idAlbaran) !== String(invoiceIdentifier)) {
          return item;
        }

        return {
          ...item,
          TotalMuestras: recalculatedSamplesTotal,
          Total: recalculatedSamplesTotal,
        };
      });

      this.setInvoice(updatedInvoices);

      if (this.invoiceDetails?.idAlbaran === invoiceIdentifier) {
        this.setInvoiceDetails({
          ...this.invoiceDetails,
          TotalMuestras: recalculatedSamplesTotal,
          Total: recalculatedSamplesTotal,
        });
      }
    },
    closeReplacementSamplePopup() {
      this.replacementSamplePopupVisible = false;
      this.navigateAfterSave();
    },
    async refreshInvoiceSamplesFromBackend() {
      const invoiceId =
        this.lastFormData?.idAlbaran ||
        this.detailedSample?.idAlbaran;

      if (!invoiceId) return;

      await this.fetchInvoiceSamples(invoiceId);
      this.syncInvoiceTotalsFromSamples(this.invoiceSamples);
    },
    async SaveSample() {
      let shouldNavigateToList = true;
      try {
        this.$f7.preloader.show();
        // console.log(
        //   '[SamplesRegisteredDetailsPage] SaveSample before update',
        //   {
        //     detailedSample: this.detailedSample,
        //     lastFormData: this.lastFormData,
        //   }
        // );

        const shouldCreateReplacementSample =
          this.shouldCreateReplacementSample();

        if (shouldCreateReplacementSample) {
          await this.deleteSample(
            this.lastFormData?.IdWMuestra ||
              this.detailedSample?.IdWMuestra
          );
          const registeredSample = await this.registerInvoiceSamples(
            this.buildRegisterPayloadFromEditedSample()
          );
          await this.refreshInvoiceSamplesFromBackend();
          this.replacementSampleCode =
            registeredSample?.CodMuestra || '';
          this.replacementSamplePopupVisible = true;
          shouldNavigateToList = false;
        } else {
          await this.updateSample(this.lastFormData);
          await this.refreshInvoiceSamplesFromBackend();
          this.$notifyDX(
            {
              message: this.$t('editSuccess'),
              width: 550,
            },
            'success',
            NOTIFY_TIME_LONG
          );
        }
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        if (
          shouldNavigateToList &&
          !this.replacementSamplePopupVisible
        ) {
          this.navigateAfterSave();
        }
        this.$f7.preloader.hide();
      }
    },
    async receiveMessage(newFormData) {
      this.lastFormData = newFormData;
      return this.lastFormData;
    },
    syncInvoicePricesAfterSave() {
      const currentSampleId =
        this.lastFormData?.IdWMuestra ||
        this.detailedSample?.IdWMuestra;
      const newSamplePrice = Number(this.lastFormData?.PrecioAT);
      const updatedArticleCode =
        this.lastFormData?.CodArticulo ||
        this.detailedSample?.CodArticulo;
      const updatedArticleLabel =
        this.lastFormData?.Articulo ||
        this.lastFormData?.AnalisisTipo ||
        this.detailedSample?.AnalisisTipo;
      const updatedAnalysisTypeId =
        this.lastFormData?.IdAnalisisTipo ||
        this.lastFormData?.CodAnalisisTipo ||
        this.detailedSample?.IdAnalisisTipo;

      if (!currentSampleId || Number.isNaN(newSamplePrice)) {
        console.log(
          '[SamplesRegisteredDetailsPage] syncInvoicePricesAfterSave skipped',
          {
            currentSampleId,
            newSamplePrice,
          }
        );
        return;
      }

      const updatedInvoiceSamples = (this.invoiceSamples || []).map(
        (sample) => {
          if (String(sample.IdWMuestra) !== String(currentSampleId)) {
            return sample;
          }

          return {
            ...sample,
            PrecioAT: newSamplePrice,
            CodArticulo: updatedArticleCode || sample.CodArticulo,
            AnalisisTipo: updatedArticleLabel || sample.AnalisisTipo,
            IdAnalisisTipo:
              updatedAnalysisTypeId || sample.IdAnalisisTipo,
          };
        }
      );

      this.setInvoiceSamples(updatedInvoiceSamples);
      console.log(
        '[SamplesRegisteredDetailsPage] updatedInvoiceSamples',
        {
          currentSampleId,
          updatedInvoiceSamples,
        }
      );

      const recalculatedSamplesTotal = updatedInvoiceSamples.reduce(
        (total, sample) => total + Number(sample?.PrecioAT || 0),
        0
      );

      const invoiceIdentifier =
        this.detailedSample?.idAlbaran ||
        this.invoiceDetails?.idAlbaran;
      const updatedInvoices = (this.invoice || []).map((item) => {
        if (String(item.idAlbaran) !== String(invoiceIdentifier)) {
          return item;
        }

        return {
          ...item,
          TotalMuestras: recalculatedSamplesTotal,
          Total: recalculatedSamplesTotal,
        };
      });

      this.setInvoice(updatedInvoices);

      if (this.invoiceDetails?.idAlbaran === invoiceIdentifier) {
        this.setInvoiceDetails({
          ...this.invoiceDetails,
          TotalMuestras: recalculatedSamplesTotal,
          Total: recalculatedSamplesTotal,
        });
        console.log(
          '[SamplesRegisteredDetailsPage] updated invoiceDetails',
          {
            invoiceDetails: {
              ...this.invoiceDetails,
              TotalMuestras: recalculatedSamplesTotal,
              Total: recalculatedSamplesTotal,
            },
          }
        );
      }
    },
    goBack() {
      this.$f7router.navigate(
        { name: 'InvoiceSamplesListDetails' },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    GoConfirmation() {
      this.$f7router.navigate(
        {
          name: 'SamplesConfirmation',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('Offers', ['fetchDetallesPresupuestos']),
    ...mapActions('samplesRegisterModule', [
      'setLmrCountries',
      'registerInvoiceSamples',
      'deleteSample',
      'updateSample',
      'fetchInvoiceSamples',
      'setInvoice',
      'setInvoiceSamples',
      'setInvoiceDetails',
    ]),
  },
};
</script>
<style scoped>
.cardRegister {
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(87, 84, 95, 0.3);
  padding: 20px;
}
.saveButton {
  margin: 0px 5px 25px;
}
.cancelButton {
  margin: 0 5px 25px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  padding: 12px;
  color: #00346a !important;
  background: #fff !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #00346a !important;
  box-shadow: none;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.2s ease;
}
.cancelButton:hover {
  background: #ebf2fa !important;
}
</style>
